import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import { cancelCreativePlan } from '@/api/creative/report';
import { advWarningAdvertiser, delWarningAdvertiser } from '@/api/advertiser/manage';
import { IsUseReviewEnum } from '@/api/creative/warning';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    configObj: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      loading: false
    };
  },

  computed: {
    confirmLabel: function confirmLabel() {
      if (this.configObj.type === 'delete') {
        return {
          title: '确定删除标签吗？',
          content: '删除标签后，素材审核列表中不会高亮显示该广告主素材。'
        };
      } else if (this.configObj.type === 'add') {
        return {
          title: '确定添加标签吗？',
          content: '添加标签后，素材审核列表中会高亮提示该广告主素材。'
        };
      }
      return {
        title: '确定取消推送吗？',
        content: '取消推送后，手动添加的广告主素材推送巡审计划会终止。'
      };
    }
  },
  methods: {
    handleClose: function handleClose() {
      if (!this.loading) {
        this.$emit('update:visible', false);
      }
    },
    handleSubmit: function handleSubmit() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                // 删除标签

                if (!(_this.configObj.type === 'delete')) {
                  _context.next = 13;
                  break;
                }

                _context.prev = 2;
                _context.next = 5;
                return delWarningAdvertiser(_this.configObj.batchAdvNames);

              case 5:
                _this.successForm();
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](2);

                _this.loading = false;

              case 11:
                _context.next = 34;
                break;

              case 13:
                if (!(_this.configObj.type === 'add')) {
                  _context.next = 25;
                  break;
                }

                _context.prev = 14;
                _context.next = 17;
                return advWarningAdvertiser(_this.configObj.batchAdvNames, IsUseReviewEnum.NO);

              case 17:
                _this.successForm();
                _context.next = 23;
                break;

              case 20:
                _context.prev = 20;
                _context.t1 = _context['catch'](14);

                _this.loading = false;

              case 23:
                _context.next = 34;
                break;

              case 25:
                _context.prev = 25;
                _context.next = 28;
                return cancelCreativePlan({ ids: _this.configObj.batchIds });

              case 28:
                _this.successForm();
                _context.next = 34;
                break;

              case 31:
                _context.prev = 31;
                _context.t2 = _context['catch'](25);

                _this.loading = false;

              case 34:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[2, 8], [14, 20], [25, 31]]);
      }))();
    },
    successForm: function successForm() {
      this.$message.success('操作成功');
      this.loading = false;
      this.handleClose();
      this.$emit('handleRefresh');
    }
  }
};